module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/order-groups/order-groups.component.css
// module id = ./src/app/order-groups/order-groups.component.css
// module chunks = main